var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 30.3337C8.09268 30.3337 1.66602 23.907 1.66602 16.0003C1.66602 8.09366 8.09268 1.66699 15.9993 1.66699C23.906 1.66699 30.3327 8.09366 30.3327 16.0003C30.3327 23.907 23.906 30.3337 15.9993 30.3337ZM15.9993 3.66699C9.19935 3.66699 3.66602 9.20033 3.66602 16.0003C3.66602 22.8003 9.19935 28.3337 15.9993 28.3337C22.7993 28.3337 28.3327 22.8003 28.3327 16.0003C28.3327 9.20033 22.7993 3.66699 15.9993 3.66699Z",
    fill: "#00204c00",
    fillOpacity: 0.968627
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2271 20.7738C11.9738 20.7738 11.7205 20.6805 11.5205 20.4805C11.1338 20.0938 11.1338 19.4538 11.5205 19.0671L19.0671 11.5205C19.4538 11.1338 20.0938 11.1338 20.4805 11.5205C20.8671 11.9071 20.8671 12.5471 20.4805 12.9338L12.9338 20.4805C12.7471 20.6805 12.4805 20.7738 12.2271 20.7738Z",
    fill: "#00204c",
    fillOpacity: 0.968627
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7738 20.7738C19.5205 20.7738 19.2671 20.6805 19.0671 20.4805L11.5205 12.9338C11.1338 12.5471 11.1338 11.9071 11.5205 11.5205C11.9071 11.1338 12.5471 11.1338 12.9338 11.5205L20.4805 19.0671C20.8671 19.4538 20.8671 20.0938 20.4805 20.4805C20.2805 20.6805 20.0271 20.7738 19.7738 20.7738Z",
    fill: "#00204c",
    fillOpacity: 0.968627
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseContent);
export default __webpack_public_path__ + "static/media/closeContent.ae7919d13b5d4a2c21cf08dc079cb02c.svg";
export { ForwardRef as ReactComponent };